export const FETCH_GENEALOGY_REPORT_LIST_REQUEST =
  "FETCH_GENEALOGY_REPORT_LIST_REQUEST";
export const FETCH_PRODUCED_PRODUCTS_REQUEST =
  "FETCH_PRODUCED_PRODUCTS_REQUEST";
export const FETCH_MANUFACTURING_SITES_REQUEST =
  "FETCH_MANUFACTURING_SITES_REQUEST";
export const FETCH_UNIT_OPERATIONS_REQUEST = "FETCH_UNIT_OPERATIONS_REQUEST";
export const FETCH_PRODUCT_DESCRIPTION_REQUEST =
  "FETCH_PRODUCT_DESCRIPTION_REQUEST";
export const FETCH_PARAMETERS_REQUEST = "FETCH_PARAMETERS_REQUEST";
export const FETCH_COMPONENTS_REQUEST = "FETCH_COMPONENTS_REQUEST";
export const FETCH_GENEALOGY_REPORT = "FETCH_GENEALOGY_REPORT";
export const FETCH_FILTERED_BATCH_LIST = "FETCH_FILTERED_BATCH_LIST";
export const REPORT_DATA = "REPORT_DATA"
export const SAVE_REPORT_DATA = "SAVE_REPORT_DATA"
export const FETCH_GENEALOGY_REPORT_BY_ID = "FETCH_GENEALOGY_REPORT_BY_ID";

